import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import CartePage from "@/pages/CartePage";
import TourneesPage from "@/pages/TourneesPage";
import UsersPage from "@/pages/UsersPage";
import LivreursPage from "@/pages/LivreursPage";
import DashboardPage from "@/pages/DashboardPage";
import ColisPage from "@/pages/ColisPage";
import ColisFichePage from "@/pages/ColisFichePage";
import ListesColisPage from "@/pages/ListesColisPage";
import ListeColisPage from "@/pages/ListeColisPage";
import DepotPage from "@/pages/DepotPage";
import InventairePage from "@/pages/InventairePage";
import CagePage from "@/pages/CagePage";
import FacturesPage, { FactureVoirPage } from "@/pages/FacturesPage";
import FactureClientPage from "@/pages/FactureClientPage";
import FamisPage from "@/pages/FamisPage";
import RemiseScanPage from "@/pages/scans/RemiseScanPage";
import ReceptionScanPage from "@/pages/scans/ReceptionScanPage";
import ConfigScanPage from "@/pages/scans/ConfigScanPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* Page publique du client : facture pro forma (lien + code d'accès, sans compte) */}
              <Route path="/facture/:token" element={<FactureClientPage />} />
              <Route path="/outils/famis" element={<ProtectedRoute perm="onglet_famis"><FamisPage /></ProtectedRoute>} />
              <Route path="/factures" element={<ProtectedRoute perm="onglet_factures"><FacturesPage /></ProtectedRoute>} />
              <Route path="/factures/:id" element={<ProtectedRoute perm="onglet_factures"><FactureVoirPage /></ProtectedRoute>} />
              <Route path="/" element={<ProtectedRoute perm="onglet_dashboard"><DashboardPage /></ProtectedRoute>} />
              <Route path="/chauffeurs" element={<ProtectedRoute perm="onglet_chauffeurs"><LivreursPage /></ProtectedRoute>} />
              <Route path="/carte" element={<ProtectedRoute perm="onglet_carte"><CartePage /></ProtectedRoute>} />
              <Route path="/carte/tournees" element={<ProtectedRoute perm="carte_tournees_voir"><TourneesPage /></ProtectedRoute>} />
              <Route path="/scans" element={<ProtectedRoute perm="scan_remise"><RemiseScanPage /></ProtectedRoute>} />
              <Route path="/scans/reception" element={<ProtectedRoute perm="scan_reception"><ReceptionScanPage /></ProtectedRoute>} />
              <Route path="/scans/config" element={<ProtectedRoute perm="scan_config"><ConfigScanPage /></ProtectedRoute>} />
              <Route path="/colis" element={<ProtectedRoute perm="colis_colis"><ColisPage /></ProtectedRoute>} />
              <Route path="/colis/depot" element={<ProtectedRoute perm="colis_depot"><DepotPage /></ProtectedRoute>} />
              <Route path="/colis/depot/inventaire" element={<ProtectedRoute perm="depot_inventaire"><InventairePage zone="depot" key="depot" /></ProtectedRoute>} />
              <Route path="/colis/cage" element={<ProtectedRoute perm="colis_cage"><CagePage /></ProtectedRoute>} />
              <Route path="/colis/cage/inventaire" element={<ProtectedRoute perm="cage_inventaire"><InventairePage zone="cage" key="cage" /></ProtectedRoute>} />
              <Route path="/colis/listes" element={<ProtectedRoute perm="colis_listes"><ListesColisPage /></ProtectedRoute>} />
              <Route path="/colis/listes/:id" element={<ProtectedRoute perm="colis_listes"><ListeColisPage /></ProtectedRoute>} />
              <Route path="/colis/:id" element={<ProtectedRoute perm="colis_colis"><ColisFichePage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
              {/* anciennes adresses */}
              <Route path="/livreurs" element={<Navigate to="/chauffeurs" replace />} />
              <Route path="/tournees" element={<Navigate to="/carte/tournees" replace />} />
              <Route path="/utilisateurs" element={<Navigate to="/admin" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
